import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import useGameStore from "./store/gameStore";
import useLicenseStore from "./store/licenseStore";
import { I18nProvider } from "./i18n";
import Layout from "./components/layout/Layout";
import CreateCompany from "./pages/CreateCompany";
import Dashboard from "./pages/Dashboard";
import Fleet from "./pages/Fleet";
import HR from "./pages/HR";
import Depot from "./pages/Depot";
import Finance from "./pages/Finance";
import FonctionsSupport from "./pages/FonctionsSupport";
import Achievements from "./pages/Achievements";
import Challenges from "./pages/Challenges";
import Atouts from "./pages/Atouts";
import Fiscalite from "./pages/Fiscalite";
import Banque from "./pages/Banque";
import Marche from "./pages/Marche";
import AppelsOffres from "./pages/AppelsOffres";
import Strategie from "./pages/Strategie";
import Capitaux from "./pages/Capitaux";
import Messagerie from "./pages/Messagerie";
import Agenda from "./pages/Agenda";
import AdminPanel from "./pages/AdminPanel";
import LicenseGate from "./pages/LicenseGate";
import WaitingRoom from "./pages/WaitingRoom";
import RexExpiredScreen from "./pages/RexExpiredScreen";
import { RexInvite } from "./components/rex/RexInvite";
import SupervisionView from "./pages/SupervisionView";
import Demo from "./pages/Demo";
import useTelemetryReporter from "./hooks/useTelemetryReporter";
import useSupervisorNotesPoller from "./hooks/useSupervisorNotesPoller";
import useObjectivesPoller from "./hooks/useObjectivesPoller";
import useBankruptcyReporter from "./hooks/useBankruptcyReporter";
import useErrorTracker from "./hooks/useErrorTracker";
import useScenarioPusher from "./hooks/useScenarioPusher";
import useDebriefingPoller from "./hooks/useDebriefingPoller";
import { EventPopup } from "./components/game/EventPopup";
import MonthlyReport from "./components/game/MonthlyReport";
import AnnualBoardMeeting from "./components/game/AnnualBoardMeeting";
import FiscalAuditModal from "./components/game/FiscalAuditModal";
import { TutorialOverlay } from "./components/game/TutorialOverlay";
// 02/06/2026 — ContractAlertPopup retiré (retour utilisateur : la pastille
// "1 véhicule dispo" en bas à droite renvoyait vers une route non
// pertinente).
import { AdvisorBubble } from "./components/game/AdvisorBubble";
import { PhaseNotification } from "./components/game/PhaseNotification";
import MarchettiBonusModal from "./components/game/MarchettiBonusModal";
import BoardMeetingModal from "./components/game/BoardMeetingModal";
import MidYearBoardMeeting from "./components/game/MidYearBoardMeeting";
import { InternationalSwitchModal } from "./components/game/InternationalSwitchModal";
import FiscalQuizModal from "./components/game/FiscalQuizModal";
import BankruptcyAlertBanner from "./components/game/BankruptcyAlertBanner";
import EmergencyShareholderModal from "./components/game/EmergencyShareholderModal";
import GameOverModal from "./components/game/GameOverModal";
import CompetitionAnalysis from "./pages/CompetitionAnalysis";
import AcquisitionModal from "./components/game/AcquisitionModal";
import ConvoyMissionCinematic from "./components/convoy/ConvoyMissionCinematic";
import SupportHireCelebration from "./components/game/SupportHireCelebration";
import AoResultNotifier from "./components/game/AoResultNotifier";
import BusinessAlertModal from "./components/game/BusinessAlertModal";
import ConceptUnlockedToast from "./components/game/ConceptUnlockedToast";
import DebriefingResponseModal from "./components/game/DebriefingResponseModal";
import { Toaster } from "./components/ui/sonner";
import ManualButton from "./components/manual/ManualButton";
import MailShortcutButton from "./components/dashboard/MailShortcutButton";
import Clients from "./pages/Clients";
import PageErrorBoundary from "./components/PageErrorBoundary";
import LegacySaveBanner from "./components/LegacySaveBanner";

function GameRoutes() {
  return (
    <Layout>
      <BankruptcyAlertBanner />
      <Routes>
        <Route path="/" element={<PageErrorBoundary label="dashboard"><Dashboard /></PageErrorBoundary>} />
        <Route path="/fleet" element={<PageErrorBoundary label="fleet"><Fleet /></PageErrorBoundary>} />
        <Route path="/hr" element={<PageErrorBoundary label="hr"><HR /></PageErrorBoundary>} />
        <Route path="/depot" element={<PageErrorBoundary label="depot"><Depot /></PageErrorBoundary>} />
        <Route path="/finance" element={<PageErrorBoundary label="finance"><Finance /></PageErrorBoundary>} />
        <Route path="/fonctions-support" element={<PageErrorBoundary label="fonctions-support"><FonctionsSupport /></PageErrorBoundary>} />
        <Route path="/achievements" element={<PageErrorBoundary label="achievements"><Achievements /></PageErrorBoundary>} />
        <Route path="/challenges" element={<PageErrorBoundary label="challenges"><Challenges /></PageErrorBoundary>} />
        <Route path="/atouts" element={<PageErrorBoundary label="atouts"><Atouts /></PageErrorBoundary>} />
        <Route path="/fiscalite" element={<PageErrorBoundary label="fiscalite"><Fiscalite /></PageErrorBoundary>} />
        <Route path="/banque" element={<PageErrorBoundary label="banque"><Banque /></PageErrorBoundary>} />
        <Route path="/capitaux" element={<PageErrorBoundary label="capitaux"><Capitaux /></PageErrorBoundary>} />
        <Route path="/marche" element={<PageErrorBoundary label="marche"><Marche /></PageErrorBoundary>} />
        <Route path="/appels-offres" element={<PageErrorBoundary label="appels-offres"><AppelsOffres /></PageErrorBoundary>} />
        <Route path="/clients" element={<PageErrorBoundary label="clients"><Clients /></PageErrorBoundary>} />
        <Route path="/concurrence" element={<PageErrorBoundary label="concurrence"><CompetitionAnalysis /></PageErrorBoundary>} />
        <Route path="/strategie" element={<PageErrorBoundary label="strategie"><Strategie /></PageErrorBoundary>} />
        <Route path="/messagerie" element={<PageErrorBoundary label="messagerie"><Messagerie /></PageErrorBoundary>} />
        <Route path="/agenda" element={<PageErrorBoundary label="agenda"><Agenda /></PageErrorBoundary>} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <EventPopup />
      <MonthlyReport />
      <AnnualBoardMeeting />
      <FiscalAuditModal />
      <TutorialOverlay />
      <AdvisorBubble />
      <PhaseNotification />
      <MarchettiBonusModal />
      <BoardMeetingModal />
      <MidYearBoardMeeting />
      <InternationalSwitchModal />
      <FiscalQuizModal />
      <EmergencyShareholderModal />
      <GameOverModal />
      <AcquisitionModal />
      <ConvoyMissionCinematic />
      <SupportHireCelebration />
      <AoResultNotifier />
      <BusinessAlertModal />
      <ConceptUnlockedToast />
      <DebriefingResponseModal />
      <ManualButton />
      <MailShortcutButton />
    </Layout>
  );
}
function AppContent() {
  const gameStarted = useGameStore((s) => s.gameStarted);
  const { validated, checking, checkLicense, waitingInfo, expiredInfo } = useLicenseStore();
  const location = useLocation();

  useEffect(() => {
    checkLicense();
  }, [checkLicense]);

  // Telemetry reporter — silent hook that ships a compact snapshot to the
  // backend at game start, monthly close, and as a 5-min fallback. Safe to
  // mount unconditionally: it self-gates on licenseKey + gameStarted.
  useTelemetryReporter();

  // Supervisor notes poller — pulls in any note posted by the responsable
  // pédagogique and surfaces them in the Messagerie. Same gating as above.
  useSupervisorNotesPoller();

  // Pedagogical objectives poller — caches active objectives into the game
  // state for the Dashboard widget, and pushes achieved/failed outcomes
  // into the Messagerie. Server-side evaluation, idempotent.
  useObjectivesPoller();

  // Bankruptcy reporter — fires exactly once per liquidation to notify the
  // backend (and via supervisor_notes the Responsable Pédagogique).
  useBankruptcyReporter();

  // 11/02/2026 (Phase 1 fiabilité) — Global error tracker. Captures
  // window.onerror + unhandledrejection and forwards to /api/reports/error.
  // Throttled by fingerprint, best-effort, never blocks the UI.
  useErrorTracker();

  // 11/02/2026 (Phase 3 — Superpouvoirs formateur) — Scenario pusher.
  // Poll les scénarios pédagogiques pushés par le formateur (choc pétrolier,
  // grève, ZFE, crue) et les applique côté apprenti via
  // `applyPushedScenario`. Best-effort, silencieux sur erreur.
  useScenarioPusher();

  // 11/02/2026 (Phase 3 v2 — Débriefing collectif) — Poll les débriefings
  // pédagogiques ciblés et pousse un message inbox. La modale de réponse
  // (`DebriefingResponseModal`) affiche un bouton flottant si des
  // débriefings sont en attente.
  useDebriefingPoller();

  // Admin panel is always accessible
  if (location.pathname === '/admin') {
    return <AdminPanel />;
  }

  // Public demo route — no license required, no telemetry.
  if (location.pathname === '/demo') {
    return <Demo />;
  }

  // Pedagogical supervisor view — gated by the master key stored in
  // localStorage during the LicenseGate validation. The page itself
  // re-checks and redirects to '/' if the key is missing.
  if (location.pathname === '/supervision') {
    return <SupervisionView />;
  }

  // While checking license status
  if (checking) {
    return (
      <div className="min-h-screen bg-[#1F3864] flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-white mb-2">HST</h1>
          <div className="w-8 h-8 border-3 border-white/30 border-t-white rounded-full animate-spin mx-auto" />
        </div>
      </div>
    );
  }

  // License not validated — waiting room, REX (licence expirée) or gate
  if (!validated) {
    if (waitingInfo) {
      return <WaitingRoom />;
    }
    if (expiredInfo) {
      return <RexExpiredScreen />;
    }
    return <LicenseGate />;
  }

  // License valid — normal game flow
  if (gameStarted) {
    return (
      <>
        <GameRoutes />
        <RexInvite />
      </>
    );
  }

  return <CreateCompany />;
}

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <LegacySaveBanner />
        <AppContent />
        {/* 05/02/2026 — Q1 engagement : Toaster global (sonner) pour
            les notifications AO + futurs feedbacks juicy. */}
        <Toaster richColors closeButton position="top-right" />
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
